export const AspectRatiosForLinkedInAds = {
  Image191x100: {
    aspectRatio: 1.91,
    type: 'Image191x100',
    associationType: 'LandscapeImageMedia',
    minSize: [690, 360],
    maxSize: [7680, 4320],
    isLogo: false,
  },
  Image1x1: {
    aspectRatio: 1,
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    minSize: [360, 360],
    maxSize: [4320, 4320],
    isLogo: false,
  },
  Image4x5: {
    aspectRatio: 0.8,
    type: 'Image4x5',
    associationType: 'PortraitImageMedia',
    minSize: [512, 640],
    maxSize: [2430, 4320],
    isLogo: false,
  },
};
